<div [hidden]="!_validData" class="text-left">
    <h4>{{_titulo}}</h4>
</div>
<!-- <div [hidden]="!_validData" id="{{_chartIndex}}"></div> -->
<!-- <div [hidden]="!_validData" id="chartpie-20"></div> -->

<div [hidden]="_validData">
    <p>Data for chart generation is invalid. Please check and try again.</p>
</div>